import { GET_ALL_DATA, GET_DIVISIONS, GET_DETAIL, ADD_DATA, UPDATE_DATA, DELETE_DATA } from '@/api/master/organization';
import querystring from 'query-string';

const state = {
	excel: [],
	list: [],
	detail: {},
};

const mutations = {
	SET_LIST: (state, payload) => {
		state.list = payload;
	},
	SET_EXCEL: (states, payload) => {
		states.excel = payload;
	},
	SET_DETAIL: (state, payload) => {
		state.detail = payload;
	},
};

const actions = {
	downloadExcel: async ({ commit }, args) => {
		const params = queryString.stringify(args);
		return await EXPORT_DATA(args)
			.then((res) => {
				const url = window.URL.createObjectURL(new Blob([res.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', args.filename + '.' + 'xlsx');
				document.body.appendChild(link);
				link.click();

				return res;
			})
			.catch((err) => {
				let resp = err.response;
				console.log(err);
			});
	},
	GET_LIST: async ({ commit }, params) => {
		params = querystring.stringify(params);
		const resp = await GET_ALL_DATA(params);
		const data = resp.data.data;
		commit('SET_LIST', data);
	},
	GET_DETAIL: async ({ commit }, id) => {
		const resp = await GET_DETAIL(id);
		const data = resp.data.data;
		commit('SET_DETAIL', data);
	},
	CREATE_DATA: async ({}, args) => {
		return await ADD_DATA(args);
	},
	UPDATE_DATA: async ({}, args) => {
		return await UPDATE_DATA(args);
	},

	DELETE_DATA: async ({}, id) => {
		return await DELETE_DATA(id);
	},
};

const getters = {
	list: (state) => state.list,
	departments: (state) => state.list.data,
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
};
